// import { checkPermission } from '@/router/guards.ts'

const WhitelistModule = () => import('./WhitelistModule.vue')
const WhitelistIndex = () => import('./views/WhitelistIndex.vue')

export const whitelistRoute = {
  path: '/whitelists',
  name: 'whitelist',
  component: WhitelistModule,
  meta: {
    title: 'Whitelists',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'whitelists-index',
      component: WhitelistIndex,
      meta: {
        // permission: 'whitelist.view',
      },
      // beforeEnter: checkPermission('whitelist.view'),
    },
  ],
}
